export enum ControlType {
  display = "display",
  speed = "speed",
  voice = "voice",
}
